module.exports = __webpack_public_path__ + "img/img2.04ef29bf.png";